
// 后台测试服务地址
export const API_BASE_URL = process.env.VUE_APP_API_BASE_URL;
// Aliyun OSS 服务基础地址
// 阿里图片地址
export const IMG_OSS_URL = process.env.VUE_APP_IMAGE_BASE_URL;

// 原工作台前台基础地址
export const OLD_BASIC_URL = process.env.VUE_APP_OLD_BASIC_URL;

// 新版云定制基础地址
export const NEXT_BASIC_URL = process.env.VUE_APP_NEXT_BASIC_URL;

// 新版云定制SSR地址
export const SSR_BASIC_URL = process.env.VUE_APP_NUXT_BASIC_URL;

// 按钮loading常量
export const BUTTON_NAME = {
    'CREATE_PROJECT': false, // 创建新项目
    'LOCAL_PROJECT': false, // 本地产品信息新建/保存
    'FAVORITE_ADD': false, // 从收藏夹添加
    'CHOICED_SPEC': false, // 选择规格
    'SAVE_PROJECT': false, // 保存项目,
    'SET_ADDRESS': false, //修改或者新增地址
    'ORDER_COMMIT': false, // 提交订单
    'COMMIY_CONTRACT': false, // 确认合同按钮
    'EXPORT_MEANS': false, // 导出面料色板
    'ORDER_DOWN_LOAD': false, //订单详情页面 附件、面料才在 loading
}

// 恐龙蛋汇率，25个蛋抵1块钱
export const EGG_EXCHARGE_RATE = 25

// exchangeMode (integer, optional): 兑换方式(1:用恐龙蛋,2:钱和恐龙蛋组合,3:钱)
export const EXCHANGE_MODE = {
    EGG: 1,
    GROUP: 2,
    MONEY: 3
}

/* 积分订单状态 */
export const ORDER_STATUS = {
    WAIT_PAY: 1,
    WAIT_PACKAGE: 2,
    WAIT_RECEIVE_PACKAGE: 3,
    WAIT_COMMENT: 4,
    FINISHED: 5,
    CANCEL: 6,
    CLOSED: 7
}